// 埋点SDK
class Track {
  constructor(config = {}) {
    Object.assign(this.defaultConfig, config);
    this.init();
  }

  clickAttr = "data-click";
  expAttr = "data-exp";
  logAttr = "data-log";
  noExpTag = "0";
  expedTag = "1";
  vWidth = window.innerWidth || document.documentElement.clientWidth;
  vHeight = window.innerHeight || document.documentElement.clientHeight;
  // 收集数据list，进行暂存批量上报。
  reportDataList = [];
  timer;

  // 默认配置
  defaultConfig = {
    // 是否上报点击
    click: true,
    // 是否上报曝光
    exp: true,
    // dom元素id
    id: "",
    // 滚动元素ID，主要用于滚动曝光
    scrollId: "",
  };

  /**
   * js调用触发上报（非用户直接行为）
   * @param {DOMElement} ele dom元素
   * @param {string} type 上报类型
   */
  fnTrackByEle = (ele, type) => {
    if (!ele || !type) return;
    switch (type) {
      case this.clickAttr:
        this.fnTrackData(ele, this.clickAttr);
        break;
      case this.expAttr:
        this.fnTrackData(ele, this.expAttr);
        break;
      default:
        break;
    }
  };

  init() {
    const { click, exp } = this.defaultConfig;
    // 根元素
    this.baseDom = this.defaultConfig.id
      ? document.getElementById(this.defaultConfig.id)
      : document.body;
    // 滚动元素，用于滚动时上报曝光
    this.baseScrollDom = this.defaultConfig.scrollId
      ? document.getElementById(this.defaultConfig.scrollId)
      : document;
    if (!this.baseDom) return;
    this.baseTrackData = {
      // 上报基础信息，浏览器UA
      ua: navigator.userAgent,
      // 系统id
      systemId: this.defaultConfig.systemId,
    };
    click && this.fnInitClick();
    exp && this.fnInitExp();
    this.report = this.defaultConfig.callback;
  }

  // 初始化曝光埋点
  fnInitExp = () => {
    const observer = new MutationObserver(this.fnHandleMutation);
    observer.observe(this.baseDom, {
      // 观察器的配置（需要观察什么变动）
      attributes: true,
      childList: true,
      subtree: true,
    });
    this.baseScrollDom.addEventListener("scroll", () => {
      this.fnHandleMutation();
    });
  };

  fnHandleMutation = this.fnDebounce(() => {
    this.fnAfterMutation(this.baseDom);
  }, 500);

  fnAfterMutation = (dom) => {
    if (!dom) return;
    const visible = this.fnJudgeDomVisible(dom);
    if (!visible) return;
    const dataExp = dom.getAttribute(this.expAttr);
    if (dataExp === this.noExpTag) {
      this.fnTrackData(dom, this.expAttr);
      this.fnAfterTrackData(dom);
    }
    const children = dom.children;
    if (children.length > 0) {
      for (let child of children) {
        this.fnAfterMutation(child);
      }
    }
  };

  fnAfterTrackData = (dom) => {
    dom.setAttribute(this.expAttr, this.expedTag);
  };

  fnJudgeDomVisible = (dom) => {
    const { display, visibility, opacity } = getComputedStyle(dom) || {};
    // 判断元素是否不可见
    if (display === "none" || visibility === "hidden" || opacity === "0")
      return false;
    const {
      width,
      height,
      left,
      rigth,
      top,
      bottom,
    } = dom.getBoundingClientRect();
    // 判断元素是否有宽高
    if (width <= 0 || height <= 0) return false;
    // 判断元素是否在视口内
    if (
      rigth < width / 2 ||
      bottom < height / 2 ||
      left > this.vWidth + width / 2 ||
      top > this.vHeight + height / 2
    ) {
      return false;
    }
    return true;
  };

  // 初始化点击埋点
  fnInitClick = () => {
    // 利用事件冒泡，进行点击劫持
    this.baseDom.addEventListener("click", this.fnHandleBaseDomClick);
  };

  fnHandleBaseDomClick = (e) => {
    if (e.target) this.fnHanderClickData(e.target);
  };

  /**
   * 遍历dom及父元素，直至根元素或者含有clickAttr属性
   * @param {*} dom dom元素
   */
  fnHanderClickData = (dom) => {
    const dataClick = dom.getAttribute(this.clickAttr);
    if (dataClick) {
      // 含有clickAttr属性，停止遍历，进行买点数据上报。
      this.fnTrackData(dom, this.clickAttr);
    } else {
      const domParent = dom.parentElement;
      domParent &&
        domParent !== this.baseDom &&
        this.fnHanderClickData(domParent);
    }
  };

  /**
   * 以dom起，遍历父元素，merge上报信息。
   * @param {*} dom
   * @param {*} type
   * @param {*} baseData
   * @returns
   */
  fnTrackData = (dom, type, baseData = { timestamp: Date.now() }) => {
    if (dom === this.baseDom) {
      Object.assign(baseData, this.baseTrackData);
      this.fnTrack(type, baseData);
      return;
    }
    const domParent = dom.parentElement;
    if (!domParent) return;
    const data = dom.getAttribute(this.logAttr);
    if (data) {
      const parseData = JSON.parse(data || null) || {};
      Object.assign(baseData, parseData);
    }
    this.fnTrackData(domParent, type, baseData);
  };

  fnTrack = (trackType, data) => {
    if (!trackType || !data) return;
    switch (trackType) {
      case this.clickAttr:
        Object.assign(data, {
          triggerId: 1,
        });
        break;
      case this.expAttr:
        Object.assign(data, {
          triggerId: 0,
        });
        break;
      default:
        break;
    }
    if (process.env.NODE_ENV === "development") {
      console.log({
        triggerType: trackType,
        data,
      });
    }
    this.reportData(data);
  };

  // 收集数据，批量上报。
  reportData = (data) => {
    if (typeof this.report !== "function") return;
    this.reportDataList.push(data);
    if (this.timer) {
      if (this.reportDataList.length === 10) {
        this.report([...this.reportDataList]);
        this.reportDataList.splice(0);
        clearTimeout(this.timer);
        this.timer = null;
      }
    } else {
      this.timer = setTimeout(() => {
        this.report([...this.reportDataList]);
        this.reportDataList.splice(0);
        this.timer = null;
      }, 1000 * 5);
    }
  };

  // 防抖
  fnDebounce(fn, time) {
    let timer;
    const _this = this;
    return function(...args) {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(function() {
        fn.apply(_this, args);
        timer = null;
      }, time);
    };
  }
}

export default Track;



// WEBPACK FOOTER //
// ./src/lego/columbus.js